module.exports = __webpack_public_path__ + "img/IconDeviceWhite.e1768ea1.svg";